<template>
    <div class="notfound">
        <br/><br/><br/><br/><br/><br/><br/>
        <h1>Error 404</h1>
    </div>
</template>

<script>

export default{
name: "NotFound"
}
</script>

<style lang="scss" scoped>
</style>